import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore,compose,applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import reducers from 'reducers';
import Routes from './routes';

import './App.css';
import 'normalize.css';
import 'flexboxgrid';


let persistedState = localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')) : {previewApps:{},user:{}};
const query = /[?&]auth(=([^&#]*)|&|#|$)/.exec(window.location.href);
if(query){
    const authQuery = atob(query[2]).split('/');
    const authFromMobile = authQuery[3] ? true : false;
    const auth = {
        clientID: authQuery[0],
        userID: authQuery[1],
        ID: authQuery[2],
        mobile: authFromMobile
    };
    persistedState={
      auth:{token:auth.ID,authenticated:true,mobile:auth.mobile},
      user:{ID:auth.userID,clientID:auth.clientID}
    };
}

const previewQuery = /[?&]preview/.test(window.location.href);
if(!persistedState.previewApps) persistedState.previewApps = {};
persistedState.previewApps.displayPreviewApps = previewQuery;

if(previewQuery) localStorage.setItem('preview',true);
persistedState.previewApps.fromPreviewQuery = localStorage.getItem('preview') === 'true' ? true : false;

function getQueryVariable(query, variable) {
    var query = query.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}

const populateSearch = window.location.search || '';
persistedState.user.urlSearchTerm = getQueryVariable(populateSearch, "app");

const intentQuery = window.location.search.match(/intent=(.+)&app=(.+)/) || '';
persistedState.user.intentAction = intentQuery[1];
persistedState.user.intentApp = intentQuery[2];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(reducers, persistedState, composeEnhancers(
    applyMiddleware(reduxThunk)
));

store.subscribe(()=>{
  let state = {...store.getState()};
  state = {
    user: state.user,
    auth: state.auth,
    notifications: undefined
  }
  localStorage.setItem('state', JSON.stringify(state))
});

class App extends Component {
  render() {
    return (
      <Provider store={store}>
          <Routes/>
	    </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js